import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

// Used for ToolbarButton and for Overflow menu button in Insert.tsx
const useToolbarButtonStyles = makeStyles({
  root: {
    ...shorthands.borderColor('transparent'),
    fontWeight: 'normal',
    justifyContent: 'left',
    whiteSpace: 'nowrap',
  },
  disabled: {
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent',
    },
    // Custom toolbar icons use hardcoded SVG fills, which ignore the disabled foreground color.
    '& svg': {
      filter: 'grayscale(1)',
      opacity: 0.45,
    },
  },
  reducePadding: {
    minWidth: 0,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
});

export default useToolbarButtonStyles;
